// extracted by mini-css-extract-plugin
module.exports = {"container":"b4a38fbc","background":"_26839f64","content":"_835f7729","items":"e2c27a86","title":"e85ecd6d","infotext":"_84f23a63","button":"_0f4c34a8"};